import { type FC } from 'preact/compat';

import WebApp from '@twa-dev/sdk';
import clsx from 'clsx';

import { addToHomeScreen } from '@/shared/helpers/telegram/add-to-home-screen';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';
import { ButtonVariant } from '@/shared/ui/button/types';
import { Button } from '@/shared/ui/button/ui';

import { ReactComponent as PlusIcon } from '@/assets/images/icons/plus.svg?react';

import s from './index.module.scss';

interface Props {
  className?: string;
}

export const AddToHomeScreenButton: FC<Props> = ({ className }) => {
  const { isKassir } = useFeatureFlag();

  const isAvailable =
    WebApp?.isVersionAtLeast('8') && isKassir && WebApp?.platform !== 'ios';

  if (!isAvailable) return null;

  return (
    <Button
      className={clsx(s.button, className)}
      variant={ButtonVariant.secondary}
      onClick={() => addToHomeScreen()}
      icon={PlusIcon}
    />
  );
};
